import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import { useEffect, useRef, useState } from "react";
import parse from 'html-react-parser';

const OverView = () => {
    const { packageViewData } = useSafariPackagesContext();
    const [open, setOpen] = useState(true);
    const [isExpanded, setIsExpanded] = useState(false);
    const [showSeeMore, setShowSeeMore] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            const content = contentRef.current;

            if (content) {
                const scrollHeight = content.scrollHeight;
                const clientHeight = content.clientHeight;

                if (scrollHeight > clientHeight + 10) {
                    setShowSeeMore(true);
                } else {
                    setShowSeeMore(false);
                }
            }
        }, 100);

        return () => clearTimeout(timer);
    }, [packageViewData?.package_description, isExpanded]);
    return (

        <div className="accordion_disscutions">
            <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
            >
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button
                            className={`accordion-button ${open ? "" : "collapsed"
                                }`}
                            type="button"
                            onClick={() => setOpen(!open)}
                            aria-expanded={open}
                            aria-controls="flush-collapseOne"
                        >
                            Overview
                        </button>
                    </h2>
                    <div
                        id="flush-collapseOne"
                        className={`accordion-collapse collapse ${open ? "show" : ""
                            }`}
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body profile-description">
                            <div className="package_description">
                                <div className={`text show-more-height ${isExpanded ? "expanded" : ""
                                    }`}
                                    ref={contentRef}>{packageViewData?.package_description && parse(packageViewData?.package_description)}</div>
                                {showSeeMore && (
                                    <div
                                        className="package-show-more show-more"
                                        onClick={() => setIsExpanded(!isExpanded)}
                                        style={{
                                            cursor: "pointer",
                                            color: "#007bff",
                                            marginTop: "8px",
                                        }}
                                    >
                                        {isExpanded ? "See Less" : "See More"}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OverView;